import * as types from './oidcActionTypes';

export default (state = {}, action) => {
    switch (action.type) {
        case types.SILENT_RENEW_ERROR:
            return Object.assign({}, { error: true });
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/oidc/silentRenewErrorReducer.js